import store from "../store";
import actionTypes, {Background} from "./pageActionTypes";

export function setBackgroundLanding() {
    store.dispatch({
        type: actionTypes.CHANGE_BACKGROUND,
        payload: Background.LANDING,
    });
}

export function setBackgroundDefault() {
    store.dispatch({
        type: actionTypes.CHANGE_BACKGROUND,
        payload: Background.DEFAULT,
    });
}

export function setBackgroundApis() {
    store.dispatch({
        type: actionTypes.CHANGE_BACKGROUND,
        payload: Background.APIS,
    });
}

export function setBackgroundLogin() {
    store.dispatch({
        type: actionTypes.CHANGE_BACKGROUND,
        payload: Background.LOGIN,
    });
}
